import { motion } from 'framer-motion';
import { useScrollProgress } from '../../../hooks/useScrollProgress';
import './ScrollIndicator.css';

export function ScrollIndicator() {
  const p = useScrollProgress();
  return (
    <motion.div
      className="scroll-indicator"
      style={{ scaleX: p }}
      initial={{ scaleX: 0 }}
    />
  );
}
